export default __webpack_public_path__ + "static/media/LogoOspedalex70.bae74c2a.png";